import React from "react";
import styled from "styled-components";
import { FontWeight, Radius, content } from "@glossy";
import { getInitials } from "@tootools/string";
import Image from "@ui-kit/identity/image";

export interface AvatarProps {
  color?: string;
  picture?: string;
  title: string;
  className?: string;
}

const Root = styled.div<{ picture: string; color: string }>`
  border: ${(props) =>
    !props.picture && `2px solid ${props.color || content(props, "primary")}`};
  width: 36px;
  height: 36px;
  border-radius: ${Radius.Medium};
  text-align: center;
  line-height: 32px;
  color: ${(props) => props.color};
  font-weight: ${FontWeight.Bold};
  overflow: hidden;
`;

export function Avatar({ color, picture, title, className }: AvatarProps) {
  return (
    <Root color={color} picture={picture} className={className}>
      {picture ? <Image size={36} url={picture} /> : getInitials(title, 2)}
    </Root>
  );
}
